import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useStore } from '../store/reducers';

const IS_DEVELOPMENT_ENVIRONMENT = process.env.NODE_ENV !== 'production';

export function LogoutView() {
  const { logout } = useStore((s) => s.users.actions);

  useEffect(() => {
    async function fetchData() {
      await logout();

      if (IS_DEVELOPMENT_ENVIRONMENT) {
        window.location.href = '/auth/login';
      } else {
        window.location.href = '/';
      }
    }
    fetchData();
  }, []);

  return <LogoutViewHelmet />;
}

const LogoutViewHelmet: React.FC = () => {
  return (
    <Helmet>
      <title>Racemap | Logout</title>
      <meta name="description" content="Logging out of your Racemap account." />
    </Helmet>
  );
};
